import { SimulationUploadCard } from '@ai-color-modules/simulation/SimulationUploadCard/SimulationUploadCard'

interface SimulationProps {
  s3Upload: (file: File) => Promise<void>
  uploading: boolean
  /** アップロードダイアログ内に差し込む追加要素（顧客選択 UI 等）。 */
  extraDialogContent?: React.ReactNode
  /** 差し込んだ追加要素が未入力のときなど、ホスト側の条件で確定ボタンを押させない。 */
  confirmDisabled?: boolean
  /** アップロード失敗時にエラー文の下へ添える一文（`SimulationImageUploader` の同名 prop）。 */
  uploadErrorNote?: string
}

export const SimulationTop: React.FC<SimulationProps> = props => {
  const { s3Upload, uploading, extraDialogContent, confirmDisabled, uploadErrorNote } = props

  return (
    <SimulationUploadCard
      ariaLabel="現況画像をアップロード"
      inputId="simulation-top-file-input"
      s3Upload={s3Upload}
      title="新しいプロジェクトを開始"
      uploading={uploading}
      extraDialogContent={extraDialogContent}
      confirmDisabled={confirmDisabled}
      uploadErrorNote={uploadErrorNote}
    />
  )
}
